import React from "react";
import styled from "@emotion/styled";
import P from "prop-types"

const Progress = ({ value, max }) => {
return(
  <ProgressContainer>
    <ProgressValue value={value} max={max} />
  </ProgressContainer>
)}

const ProgressContainer = styled.div`
  overflow: hidden;
  position: relative;
  height: 3px;
  background-color: #bfb4b4;
`;

const ProgressValue = styled.div`
  transition: width 0.4s;
  width: ${props => props.value === 0 ? '0px' : `${(props.value / props.max) * 100}%`};
  height: 100%;
  background-color: #0bcc0b;
`;

Progress.prototype = {
  value: P.number.isRequired,
  max: P.number.isRequired
};

Progress.defaultProps = {
  value: 0,
  max : 0
};

export default Progress;
